import secureLocalStorage from "react-secure-storage";
import { Popup } from "@progress/kendo-react-popup";
import React from "react";
import { PureComponent } from "react";
import { TextArea } from "@progress/kendo-react-inputs";
import Api from "../../../Services/Api";
import * as moment from "moment";
import { CircularProgress } from "@material-ui/core";

export default class RiskProgressPopup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      temp: undefined, //this.props.dataItem[this.props.field],
      historyList:[],
      flag:true,
      loader: false
    };

  }
 
  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  onSubmit = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
    let updateData = {
      ...this.props.dataItem,
      [this.props.field]: this.state.temp,
    };
    this.props.updateDropdownValue(updateData);
    this.closePopup();
  };

  riskProgressComments = async () => {
    try {
        this.setState({loader: true})
      let req = {
        RiskRegisterId: this.props.dataItem.riskRegisterId,
      };
      let response = await Api.riskProgressComments(req);
      if (response.status === 200) {
        this.setState({...this.state,historyList:response.riskImpactComments,flag:false,loader: false});
      } else {
        this.setState({...this.state,historyList:[],flag:false,loader: false});
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleEditCell = () => {
    if (this.props.dataItem.riskRegisterId) {
      this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  closePopup = () => {
    this.props.exitEdit();
  };
  handleOnBlur = (e) => {
    return;
  };

  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;
    const value = this.props.dataItem[this.props.field];
    const isClosed = dataItem.isClosed === "Closed";
    if (
      (this.props.field && this.props.field === this.props.dataItem.inEdit) ||
      this.props.dataItem.inEdit === true
    ) {
        if(this.state.flag){
            this.riskProgressComments();
        }
      return (
        <td>
          <Popup
            show={this.props.field === this.props.dataItem.inEdit}
            popupClass={"popup-content"}
          >
              {this.state.loader ? (
                            <span className="MatTableSpinner">
                                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                            </span>
                        ) : null}
            <div className="deleteModelCont stackHolderSelection">
              <label className="fieldLabel">Add comments</label>
              <br></br>
              <div className="row cmttextarea">
                <div className="col-sm-3 col-md-7">
                  <TextArea
                    onChange={this.handleChange}
                    onBlur={this.handleOnBlur}
                    disabled={isClosed}
                  />
                </div>
                <div className="col-sm-3 col-md-3">
                  <div className="progressBtn">
                    <button
                      className="greenbtn"
                      type="button"
                      onClick={this.onSubmit}
                      disabled={isClosed ||!this.state.temp}
                    >
                      Submit
                    </button>
                    &nbsp;&nbsp;
                    <button
                      onClick={this.closePopup}
                      className="redbtn"
                      type="button"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
              <br></br>
              <label className="fieldLabel">Progress History</label>
              <div className="commentsHistory">
                <ul className="comments">
                  {this.state.historyList.map((item) => (
                    <li>
                      <p>{item.riskComment}</p>
                      <small>Date:{moment(new Date(item.createdDate)).format("DD-MMM-yyyy HH:mm:ss")}</small>{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                      <small>Entered by:{item.userName}</small>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Popup>
        </td>
      );
    }
    if (this.props.dataItem.inEdit !== this.props.field) {
      if (loginUserId === ownerId) {
        return (
          <td
            onClick={this.handleEditCell}
            style={{ left: "437px", right: "0px" }}
            title={value}
          >
            <span>{value}</span>
          </td>
        );
      } else {
        return this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.role == "View Only" ? (
          <td style={{ left: "290px", right: "0px" }} title={value}>
            <span>{value}</span>
          </td>
        ) : (
          <td
            onClick={this.handleEditCell}
            style={{ left: "437px", right: "0px" }}
            title={value}
          >
            <span>{value}</span>
          </td>
        );
      }
    }
  }
}
